import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { DateFormatConstants } from '../constants/date-formats';

/**
 * Custom Date Adapter to ensure consistent MM/DD/YYYY formatting
 * in Material Date Pickers regardless of browser locale
 */
@Injectable()
export class AppDateAdapter extends NativeDateAdapter {

  override parse(value: any): Date | null {
    if (!value) return null;
    
    if (typeof value === 'string') {
      // Handle MM/DD/YYYY format specifically
      const parts = value.split('/');
      if (parts.length === 3) {
        const month = parseInt(parts[0], 10);
        const day = parseInt(parts[1], 10);
        const year = parseInt(parts[2], 10);
        
        if (!isNaN(month) && !isNaN(day) && !isNaN(year)) {
          return new Date(year, month - 1, day);
        }
      }
    }
    
    return super.parse(value);
  }

  override format(date: Date, displayFormat: Object): string {
    if (!date || isNaN(date.getTime())) {
      return '';
    }

    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();

    // Always return MM/DD/YYYY format regardless of locale
    return `${month}/${day}/${year}`;
  }

  override getFirstDayOfWeek(): number {
    // Sunday as first day (US standard)
    return 0;
  }
}